"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as r } from "react";
import m from "../components/Icon/SvgIcon.js";
const l = (e) => /* @__PURE__ */ o(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.555 6.259h18.89a.634.634 0 0 0 0-1.259H2.555a.634.634 0 0 0 0 1.259m18.89 6.736H2.555a.634.634 0 0 1 0-1.258h18.89a.634.634 0 0 1 0 1.258m0 6.727H2.555a.634.634 0 0 1 0-1.259h18.89a.634.634 0 0 1 0 1.259",
        clipRule: "evenodd"
      }
    )
  }
), n = r(l);
export {
  n as Hamburger,
  n as default
};
